
import VideoVertical from "../../../assets/duotone/VideoVertical.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VideoVerticalIcon({ className, dataTestid = "VideoVerticalIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VideoVertical data-testid={dataTestid} className={classes} {...rest} />
  );
}
